import { render } from "./ProfileSettingsUsername.vue?vue&type=template&id=2be4caa2&ts=true"
import script from "./ProfileSettingsUsername.vue?vue&type=script&lang=ts"
export * from "./ProfileSettingsUsername.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__